import { createForm } from "@Roo/Common/EditProfile/formContext";
import { MeetYourRep } from "@Roo/api/vet";

export const { useFormContext, FormProvider } = createForm<MeetYourRep>();
